import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  protected _config = {
    apiUrl: environment.apiUrl,
    system: 'PA 3.0',
  };

  get(key: string): any {
    return this._config[key];
  }

  /**
   * Returns the API URL with the 'json' suffix.
   */
  get apiUrl(): string {
    return `${this._config.apiUrl}json`;
  }

  /**
   * Returns the system name.
   */
  get system(): string {
    return this._config.system;
  }
}
